// extracted by mini-css-extract-plugin
export var blue = "InfoGraphicListTitle-module--blue--htRgd";
export var date = "InfoGraphicListTitle-module--date--i1M-W";
export var label = "InfoGraphicListTitle-module--label--dG+oH";
export var orange = "InfoGraphicListTitle-module--orange--2lEo-";
export var root = "InfoGraphicListTitle-module--root--x5zRt";